import React from 'react';
import { useTranslation } from 'react-i18next';

interface ExportField {
  header: string;
  field: string;
  customExport?: (data: any) => string;
}

interface ExportProps {
  data: any[];
  exportFields: ExportField[]; // Array of fields and headers
}

const Export: React.FC<ExportProps> = ({ data, exportFields }) => {
  const { t } = useTranslation(['common']);
  const getValueByPath = (obj: any, path: string) => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  };

  const processField = (item: any, field: ExportField) => {
    if (field.customExport) {
      return field.customExport(getValueByPath(item, field.field));
    }
    return getValueByPath(item, field.field);
  };

  const convertToCSV = (objArray: any[]) => {
    const csvRows = [];
    // Header
    csvRows.push(exportFields.map((f) => f.header).join(','));

    // Rows
    objArray.forEach((item) => {
      const values = exportFields.map((field) => {
        const rawValue = processField(item, field);
        const escaped = ('' + rawValue).replace(/"/g, '\\"');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(','));
    });

    return csvRows.join('\r\n');
  };

  const handleExport = () => {
    const csvData = convertToCSV(data);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'export.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button
      onClick={handleExport}
      className="bg-primary/50 text-primary/300 rounded-md border px-4 h-10 text-center"
    >
      {t('export')}
    </button>
  );
};

export default Export;
